import React from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import {Button, Menu, Dropdown, Icon, Checkbox} from 'antd';

class HistorySetting extends React.PureComponent {
    state = {
        isOpen: false
    };

    toggleDropdown() {
        this.setState(state => ({isOpen: !state.isOpen}));
    }

    onChangeOption(optionKey, event) {
        let values = event.target.checked
            ? [...this.props.values, optionKey]
            : this.props.values.filter(value => value !== optionKey);

        this.props.onChange(values);
    }

    render() {
        const { t } = this.props;

        return (
            <Dropdown
                visible={this.state.isOpen}
                overlay={this.renderMenu()}
                trigger={['click']}
                overlayClassName="a-dropdown--set-field"
            >
                <Button
                    onClick={this.toggleDropdown.bind(this)}
                    type="primary"
                    className="a-btn a-btn--primary a-btn--h-25 a-btn--font-small a-text--regular _btn_setting_shbarcode"
                    ghost
                >
                    {t('setting_info_column')}
                </Button>
            </Dropdown>
        );
    }

    renderMenu() {
        return (
            <Menu className="a-dropdown--set-field__menu">
                <div className="close-field-menu">
                    <Icon onClick={() => this.setState({isOpen: false})} type="close"/>
                </div>
                {this.props.options.map(option => (
                    <Menu.Item 
                        key={option.key} 
                        className="a-dropdown--set-field__item _set-filed_shbarcode"
                    >
                        <Checkbox
                            className="a-checkbox--set-field _set-item-filed_shbarcode"
                            checked={this.props.values.includes(option.key)}
                            disabled={option.disabled}
                            onChange={this.onChangeOption.bind(this, option.key)}
                        >{this.props.t('barcode:scanning_history.column.' + option.key)}</Checkbox>
                    </Menu.Item>
                ))}
            </Menu>
        )
    }
}

HistorySetting.defaultProps = {
    options: [],
    values: [],
    onChange: (values) => {},
};

HistorySetting.propTypes = {
    options: PropTypes.array,
    values: PropTypes.array,
    onChange: PropTypes.func,
};

export default withTranslation()(HistorySetting);